'use strict';

var eventBus = require('@nextcloud/event-bus');

var token = undefined;
var observers = [];
/**
 * Get current request token
 *
 * @return {string|null} Current request token or null if not set
 */
function getRequestToken() {
    if (token === undefined) {
        // Only on first load, try to get token from document
        var tokenElement = document === null || document === void 0 ? void 0 : document.getElementsByTagName('head')[0];
        token = tokenElement ? tokenElement.getAttribute('data-requesttoken') : null;
    }
    return token;
}
/**
 * Add an observer which is called when the CSRF token changes
 *
 * @param observer The observer
 */
function onRequestTokenUpdate(observer) {
    observers.push(observer);
}
// Listen to server event and keep token in sync
eventBus.subscribe('csrf-token-update', function (e) {
    token = e.token;
    observers.forEach(function (observer) {
        try {
            observer(e.token);
        }
        catch (e) {
            console.error('error updating CSRF token observer', e);
        }
    });
});

/// <reference types="@nextcloud/typings" />
var getAttribute = function (el, attribute) {
    if (el) {
        return el.getAttribute(attribute);
    }
    return null;
};
var currentUser = undefined;
function getCurrentUser() {
    if (currentUser !== undefined) {
        return currentUser;
    }
    var head = document === null || document === void 0 ? void 0 : document.getElementsByTagName('head')[0];
    if (!head) {
        return null;
    }
    // No user logged in so cache and return null
    var uid = getAttribute(head, 'data-user');
    if (uid === null) {
        currentUser = null;
        return currentUser;
    }
    currentUser = {
        uid: uid,
        displayName: getAttribute(head, 'data-user-displayname'),
        isAdmin: (typeof OC === 'undefined') ? false : OC.isUserAdmin(),
    };
    return currentUser;
}

exports.getCurrentUser = getCurrentUser;
exports.getRequestToken = getRequestToken;
exports.onRequestTokenUpdate = onRequestTokenUpdate;
//# sourceMappingURL=index.js.map
